import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import Header from './components/Header';
import Hero from './components/Hero';
import Features from './components/Features';
import ContactForm from './components/ContactForm';
import Footer from './components/Footer';
import GoogleAnalytics from './components/GoogleAnalytics';

function App() {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    setIsLoaded(true);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-dark-900 via-dark-800 to-dark-900 text-white overflow-x-hidden">
      <GoogleAnalytics />
      {/* Optimized 3D background elements */}
      <div className="fixed inset-0 overflow-hidden pointer-events-none">
        {/* Floating 3D orbs */}
        <div className="absolute top-20 left-10 w-72 h-72 bg-primary-500/10 rounded-full blur-3xl floating-3d"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-purple-500/10 rounded-full blur-3xl floating-3d" style={{ animationDelay: '2s' }}></div>
        
        {/* Rotating elements */}
        <div className="absolute top-1/4 right-1/4 w-32 h-32 bg-gradient-to-r from-primary-400/20 to-purple-400/20 rounded-lg rotate-3d"></div>
        <div className="absolute bottom-1/3 left-1/3 w-24 h-24 bg-gradient-to-r from-blue-400/20 to-cyan-400/20 rounded-full rotate-3d" style={{ animationDelay: '5s' }}></div>
      </div>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: isLoaded ? 1 : 0 }}
        transition={{ duration: 0.8 }}
        className="relative z-10"
      >
        <Header />
        <Hero />
        <Features />
        <ContactForm />
        <Footer />
      </motion.div>
    </div>
  );
}

export default App; 